import { render, staticRenderFns } from "./BackofficeInfos.vue?vue&type=template&id=f7bca962&scoped=true"
import script from "./BackofficeInfos.vue?vue&type=script&lang=js"
export * from "./BackofficeInfos.vue?vue&type=script&lang=js"
import style0 from "./BackofficeInfos.vue?vue&type=style&index=0&id=f7bca962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bca962",
  null
  
)

export default component.exports